

import { ARCHIVE_PATCH_ITEM } from '../modules/archive';


export function createMiddleware() {
  return store => next => action => {
    const { type, payload } = action;
    const { project } = store.getState();

    switch (type) {
      case ARCHIVE_PATCH_ITEM:
        if(project && project.useMarineProducts ) {
          // if marine is true => reset layers
          next({
            ...action,
            payload: {
              ...payload
            },
            useMarineProducts: true
          });
        } else {
          next(action);
        }
        break;

        default:
        next(action);
    }
  };
}
